/** Per-request/voice-turn follow-up evidence. No grant, write or automatic reuse. */
type Call={mode:string;tool?:string;arguments?:Record<string,unknown>};
const uuid=(v:unknown):v is string=>typeof v==='string'&&/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(v);
const name=(v:unknown)=>typeof v==='string'?v.trim().toLowerCase():'';
export function createTaskFollowupEvidence(scope:string){
 const [org,user]=scope.split(':');
 const projects=new Map<string,string>();
 const pages=new Map<string,Map<number,any[]>>();
 return {
  clear(){projects.clear();pages.clear();},
  remember(call:Call,out:any,ok=true){
   if(!uuid(org)||!uuid(user))return;
   const a=call.arguments||{};
   const invalidate=()=>{for(const key of pages.keys())if(key.startsWith(a.project_id+':'))pages.delete(key);};
   if(call.mode!=='request')return;
   if(call.tool==='crm_projects_get'&&ok&&out?.status==='read'&&out.result?.success===true){
    const p=out.result.data;
    if(uuid(p?.id)&&p.id===a.project_id&&p.organization_id===org&&name(p.name))projects.set(name(p.name),p.id);
   }
   if(call.tool!=='crm_tasks_list'||!uuid(a.project_id))return;
   if(!ok||out?.status!=='read'||out.result?.success!==true||!Array.isArray(out.result.data)){invalidate();return;}
   // Any filter could hide a duplicate. Only a full project listing counts.
   if(Object.keys(a).some(k=>!['project_id','page','limit','sort_by','sort_order'].includes(k))){invalidate();return;}
   const limit=Number(a.limit||20),page=Number(a.page||1),rows=out.result.data;
   if(!Number.isSafeInteger(limit)||limit<1||limit>100||!Number.isSafeInteger(page)||page<1||page>10||rows.length>limit){invalidate();return;}
   if(rows.some((r:any)=>!uuid(r?.id)||r.project_id!==a.project_id||r.project?.id!==a.project_id||r.project.organization_id!==org)){invalidate();return;}
   for(const r of rows)if(name(r.project.name))projects.set(name(r.project.name),r.project_id);
   const key=a.project_id+':'+limit+':'+String(a.sort_by||'created_at')+':'+(a.sort_order==='asc'?'asc':'desc');const known=pages.get(key)||new Map();known.set(page,rows);pages.set(key,known);
  },
  issue(call:Call,active:boolean){
   if(!active||call.mode!=='request'||call.tool!=='crm_tasks_create')return null;
   const a=call.arguments||{},project=uuid(a.project_id)?a.project_id:projects.get(name(a.project_id));
   if(!project)return {error:'task_followup_project_lookup_required',instruction:'Prima della nuova task risolvi il progetto scelto con una lettura autorizzata, poi usa il suo UUID per leggere crm_tasks_list. Non chiedere ID tecnici all’utente. Nessuna proposta preparata.'};
   let complete:any[]|null=null,next=1,limit=100;
   for(const [key,known] of pages){
    if(!key.startsWith(project+':'))continue;
    const size=Number(key.split(':')[1]);let collected:any[]=[];
    for(let p=1;p<=10;p++){
     const rows=known.get(p);
     if(!rows){next=p;limit=size;break;}
     collected.push(...rows);
     if(rows.length<size){complete=collected;break;}
     next=p+1;limit=size;
    }
    if(complete)break;
   }
   if(!complete&&next>10)return {error:'task_followup_read_limit',instruction:'La lettura del progetto non è completa entro il limite di questa sessione. Non preparare una nuova task come se avessi escluso duplicati: spiega il limite e proponi una verifica manuale.'};
   if(!complete)return {error:'task_followup_read_required',instruction:'Prima di proporre la task successiva leggi crm_tasks_list sul progetto '+project+' senza filtri di stato, priorità o assegnatario. Usa page '+next+' e limit '+limit+'. Se la pagina è piena continua con quella successiva: una pagina incompleta non prova assenza di duplicati. Non preparare la proposta finché la lettura non è completa. Nessuna scrittura eseguita.'};
   const who=a.assigned_to==='self'?user:a.assigned_to;
   const duplicate=complete.find(r=>!r.is_header&&!['completed','cancelled'].includes(r.status)&&name(r.title)===name(a.title)&&r.assigned_to===who&&typeof r.due_date==='string'&&Date.parse(r.due_date)===Date.parse(String(a.due_date)));
   if(duplicate)return {error:'task_followup_already_exists',instruction:'Esiste già una task non completata con stesso titolo, responsabile e scadenza: '+duplicate.title+'. Non preparare una seconda proposta identica. Spiega che il prossimo passo è già presente; se vuole cambiarlo chiarisci la modifica.'};
   return null;
  }
 };
}
